import React, { useState, useContext, useMemo } from 'react';

import PropTypes from 'prop-types';

const Context = React.createContext();

export function useStyleGuideContext() {
  return useContext(Context);
}

export default function StyleGuideContext({ tagList, children }) {
  const [filterValues, setFilterValues] = useState([]);

  const value = useMemo(
    () => ({
      filterValues,
      setFilterValues,
      tagList,
    }),
    [filterValues, tagList]
  );
  return <Context.Provider value={value}>{children}</Context.Provider>;
}

StyleGuideContext.propTypes = {
  children: PropTypes.node,
  tagList: PropTypes.string,
};
